import * as joda from "@js-joda/core";
import h from "trader-hyperscript";
import {
  lessongroupid,
  phone_type,
  studentemailid,
  studentid,
  studentphoneid,
  weekday,
} from "../../../sql/classy/types";
import {
  downloadCsvFromTable,
  downloadXlsFromTable,
} from "../../client/downloadtable";
import { parseWeekday } from "../../parsing_from_ur";
import { HHmm, ddMMyyyy, renderFirstNameLastName } from "../../render";
import * as routes from "../../routes";
import { translateWeekday } from "../../translations_specific";
import { groupByIntoArrays } from "../../lib/groupbyintoarrays";
import { calculateAge } from "../../lib/time";

export function render(opts: {
  lessongroups: {
    id: lessongroupid;
    weekday: weekday;
    time: joda.LocalTime;
    stu:
      | {
          id: studentid;
          firstname: string;
          lastname: string;
          birthday: null | joda.LocalDate;
          emails:
            | {
                id: studentemailid;
                email: string;
              }[]
            | null;
          phones:
            | {
                id: studentphoneid;
                number: string;
                description: phone_type | null;
              }[]
            | null;
        }[]
      | null;
  }[];
}): HTMLElement | HTMLElement[] {
  const tableId = "classy_school_table_1";
  // Server gives me all my lgs, with students
  // Teachers gave feedback it's better to group on students, have that as first column, and then show the rest of the info after
  const students = opts.lessongroups.flatMap((lg) =>
    (lg.stu || []).map((stu) => ({ stu, lg })),
  );
  const today = joda.LocalDate.now();
  const table = (
    <table id={tableId}>
      <tbody>
        <tr>
          <th>{"Student"}</th>
          <th>{"Tijdstip"}</th>
          <th>{"Geboortedatum"}</th>
          <th>{"Telefoon"}</th>
          <th>{"Email"}</th>
        </tr>

        {groupByIntoArrays(students, (s) => s.stu.id)
          .orderBy(([_, stu]) => renderFirstNameLastName(stu[0].stu))
          .map(([_, stu]) => {
            const student = stu[0].stu;
            const lgs = stu.map((stu) => stu.lg);
            const lgCell = (
              <td>
                {lgs
                  .orderBy([
                    (lg) => parseWeekday(lg.weekday).ordinal(),
                    (lg) => lg.time.toSecondOfDay(),
                  ])
                  .map((lg) => (
                    <div>
                      <a
                        href={routes.lessongroup_generalRoute.link({
                          lessongroupid: lg.id,
                        })}
                      >
                        {translateWeekday(parseWeekday(lg.weekday))} om{" "}
                        {lg.time.format(HHmm)}
                      </a>
                    </div>
                  ))}
              </td>
            );
            return (
              <tr>
                <td>
                  <a
                    href={routes.studentOverviewRoute.link({
                      studentid: student.id,
                    })}
                  >
                    {renderFirstNameLastName(student)}
                  </a>
                </td>
                {lgCell}
                <td>
                  {student.birthday
                    ? student.birthday.format(ddMMyyyy) +
                      " (" +
                      "%age jaar".replace(
                        "%age",
                        calculateAge({
                          birthday: student.birthday,
                          today,
                        }).toString(),
                      ) +
                      ")"
                    : ""}
                </td>
                <td>
                  {(student.phones || []).map((p) => (
                    <div>{p.number}</div>
                  ))}
                </td>
                <td>
                  {(student.emails || []).map((em) => (
                    <div>{em.email}</div>
                  ))}
                </td>
              </tr>
            );
          })}
      </tbody>
    </table>
  );
  return opts.lessongroups.length === 0 ? (
    <div style="font-style: italic; text-align: center">
      {"Geen actieve studenten"}
    </div>
  ) : (
    <div>
      <article style="font-size: 0.85em; text-align: right;">
        <a
          style="margin-right: 8px;"
          onclick={() =>
            downloadXlsFromTable("students", tableId, {
              replaceNewlinesWithCommas: true,
            })
          }
        >
          {"Download als xls"}
        </a>
        <a
          onclick={() =>
            downloadCsvFromTable("students", tableId, {
              replaceNewlinesWithCommas: true,
            })
          }
        >
          {"Download als csv"}
        </a>
      </article>
      <div style="overflow-x: auto;">{table}</div>
    </div>
  );
}
